import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseUprightsStepsWorker } from '../workers/uprights.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseUprightsSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseUprightsStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseUprightsStepsWorker | Remote<WarehouseUprightsStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/uprights.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseUprightsStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseUprightsStepsWorker()];
  }
}

export class WarehouseDownloadUprightsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_UPR_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download uprights sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseUprightsSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanUprightsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_UPR_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean uprights sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseUprightsSyncWorkerFactory(), taskBreaker);
  }
}
